import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'
import LinearProgress from '@material-ui/core/LinearProgress'

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
})

function LinearDeterminate(props) {
  const classes = useStyles()
  const { progress } = props

  return (
    <div className={classes.root}>
      <LinearProgress variant="determinate" value={progress} />
    </div>
  )
}

const AiLoading = props => {
  const { progress = 0 } = props

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          maxWidth: '300px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src="/assets/new_mascot_noline_1.gif"
          height={200}
          style={{ margin: '0 auto' }}
          alt="AI Loading"
        />
        <Box m={0.5}></Box>
        <LinearDeterminate progress={progress} />
        <Box m={0.5}></Box>
        <Typography variant="h4" color="primary">
          AI Assistant is in action!
        </Typography>
        <Typography variant="subtitle" style={{ paddingBottom: '10px' }}>
          Please wait, AI can take up to 1 minute.
        </Typography>
      </div>
    </div>
  )
}

export default withStyles({})(AiLoading)
